import {
  SingleProviderConfig,
  ShopType,
  CheckoutType,
  CrossSellType,
} from 'types';
import { asyncEligible, getDefaultCrossSellAction } from 'config';
import {
  Comcast,
  Cox,
  Spectrum,
  Mediacom,
  Optimum,
  Wave,
  Grande,
  RCN,
  WOW,
  TDS,
  BuckeyeBroadband,
  ATT,
  Brightspeed,
  BrightspeedV2,
  CenturyLink,
  QuantumFiber,
  Frontier,
  Windstream,
  CincinnatiBell,
  Verizon,
} from 'config/providers';
import { CoxTheme } from 'config/themes';

export const CoxCableSpecialShop: SingleProviderConfig = {
  name: 'CoxCableSpecialShop',
  micrositeCode: 'cox_branded_shop',
  mainProvider: Cox,
  shopType: ShopType.SINGLE_PROVIDER,
  domain: 'coxcablespecial.com',
  homepage: 'https://shop.coxcablespecial.com',
  title: 'Cox Authorized Dealer',
  fallbackPhoneNumber: '855-731-6095',
  fallbackLeadModePhoneNumber: '800-972-1372',
  defaultCheckoutType: CheckoutType.LEAD_MODE,
  defaultTheme: CoxTheme,
  needsDcSession: false,
  source: 'Cox',
  noOffersRetry: 2,
  movingAppBuyflowUrls: {
    development: 'http://localhost:3000/guest/tvi/buy',
    staging: 'https://staging-cart.coxcablespecial.com/guest/tvi/buy',
    qa: 'https://staging-cart.coxcablespecial.com/guest/tvi/buy',
    production: 'https://cart.coxcablespecial.com/guest/tvi/buy',
  },
  getCrossSellAction: getDefaultCrossSellAction,
  getCheckoutType: asyncEligible,
  crossSellProviders: [
    Comcast,
    Spectrum,
    Mediacom,
    Optimum,
    Wave,
    Grande,
    RCN,
    WOW,
    TDS,
    BuckeyeBroadband,
  ],
  updaterCrossSellActive: true,
  updaterCrossSellProviders: [
    ATT,
    Brightspeed,
    BrightspeedV2,
    CenturyLink,
    QuantumFiber,
    Frontier,
    Windstream,
    CincinnatiBell,
    Verizon,
  ],
};
